import { useCustomerEventAdminTableDataRetrieveSuspense } from "gen/endpoints/customer-event-admin/customer-event-admin";
import { produce } from "immer";
import React, { useCallback } from "react";
import { DataTable } from "shared/components/table/data/DataTable";
import { DataTableProps } from "shared/components/table/data/DataTableProps";
import { GetLinkInfoForCellFn } from "shared/components/table/data/DataTableTypes";
import { rootRoute } from "shared/navigation/Routes";

export interface AdminEventsTableProps extends Partial<DataTableProps> {
  fundFamilyId: string | undefined;
  rollbackMode?: boolean;
}

export const EventsTable: React.FC<AdminEventsTableProps> = ({
  fundFamilyId,
  rollbackMode,
  ...props
}) => {
  const { data: eventTableData } =
    useCustomerEventAdminTableDataRetrieveSuspense(
      {
        fund_family_id: fundFamilyId,
        omit_transaction_code_events: rollbackMode,
      },
      {
        query: {
          // hide fund family name column if fundFamilyId is provided
          select: fundFamilyId
            ? (data) =>
                produce(data, (draft) => {
                  draft.columns = draft.columns.filter(
                    (column) => column.id !== "fund_family_name",
                  );
                })
            : undefined,
        },
      },
    );

  const getLinkInfoForCell = useCallback<GetLinkInfoForCellFn>((props) => {
    if (
      props.columnContext.column.id == "created_datetime" &&
      props.type == "data" &&
      props.row.data?.metadata?.type == "customer_event"
    ) {
      return {
        type: "generic",
        to: rootRoute({}).admin({}).events({}).event({
          customerEventId: props.row.data.metadata.original_customer_event_id,
        }).$,
      };
    }
    return undefined;
  }, []);

  return (
    <DataTable
      data={eventTableData}
      disablePinnedHeaderColumns={true}
      getLinkInfoForCell={rollbackMode ? undefined : getLinkInfoForCell}
      lockColumns={true}
      {...props}
    />
  );
};
